import './ChooseLanguage.less';
import Icon from '@/components/iconfont/Icon.jsx';
import select from '@/assets/select.png';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export default function ChooseLanguage({
  languageList,
  language_action,
  language_disabled,
  onChang,
}) {
  const { t } = useTranslation();
  const [filteredLanguages, setFilteredLanguages] = useState(languageList);
  const [data, setData] = useState('');
  const searchLanguage = (event) => {
    setData(event.target.value.trim());
    const value = event.target.value.trim().toLowerCase();
    // const language = languageList.filter(
    //   (item) =>
    //     item.name.toLowerCase().includes(value) || item.language.toLowerCase().includes(value),
    // );
    const data1 = languageList.filter((item) => item.language.toLowerCase().includes(value));
    const data2 = languageList.filter((item) => item.name.toLowerCase().includes(value));
    const language = [...data1, ...data2];
    const uniqueMap = new Map(language.map((item) => [item.name, item]));
    const uniqueData = Array.from(uniqueMap.values());
    setFilteredLanguages(uniqueData);
  };
  const clearInputData = () => {
    setData('');
    setFilteredLanguages(languageList);
  };
  return (
    <div className="ChooseLanguage">
      <label className="input input-bordered flex items-center max-w-xs search">
        <Icon name="icon-search" />
        <input
          value={data}
          type="text"
          className="max-w-xs search-input"
          placeholder={t('As_Edit_UploadSearchLang334')}
          onChange={searchLanguage}
          autoFocus={true}
          maxLength={30}
        />
        {data && <Icon name="icon-close-stroke" className="clear" onClick={clearInputData} />}
      </label>
      {/*<div className="line"></div>*/}
      <div className="languageList">
        {filteredLanguages.length > 0 ? (
          filteredLanguages?.map((language, index) => (
            <div
              className={`select_item ${language_disabled?.name === language?.name && 'languageDisabled'}`}
              key={index}
              onClick={() => {
                if (language_disabled?.name === language?.name) return;
                onChang(language);
              }}>
              {`${language.name}(${language.language})`}
              {language.name === language_action?.name && (
                <img src={select} className="select-icon" />
              )}
            </div>
          ))
        ) : (
          <div className="select_item no_data">{t('As_Home_NoLang')}</div>
        )}
      </div>
    </div>
  );
}
